import axios from 'axios';
import config from './config';
import { util, lg } from 'utils';

let base = util.getDomain();

/*代理商列表*/
export const GetAgentList = params => { return axios.get(`${base}/api/Common/GetAgentList`, { params: params }); };

/*订单列表*/
export const ERP_OrderDel = params => { return axios.post(`${base}/api/Order/ERP_OrderDel`, params, config); };
export const GetOrderByPage = params => { return axios.get(`${base}/api/Order/GetOrderByPage`, { params: params }); };
export const GetOrderExport = params => { return axios.get(`${base}/api/Order/GetOrderExport`, { params: params }); };
//审核订单 - 通过
export const ERP_AuditOrder = params => { return axios.get(`${base}/api/Order/ERP_AuditOrder`, { params: params }); };
export const GetOrderAuditByPage = params => { return axios.get(`${base}/api/Order/GetOrderAuditByPage`, { params: params }); };
export const GetAuditOrderById = params => { return axios.get(`${base}/api/Order/GetAuditOrderById`, { params: params }); };
export const ERP_OrderAdd = params => { return axios.post(`${base}/api/Order/ERP_OrderAdd`, params, config); };
//获取单条数据
export const GetERP_OrderById = params => { return axios.get(`${base}/api/Order/GetERP_OrderById`, { params: params }); };
//更新订单
export const ERP_OrderUpdate = params => { return axios.post(`${base}/api/Order/ERP_OrderUpdate`, params, config); };
//作废订单
export const ERP_InvalidOrder = params => { return axios.get(`${base}/api/Order/ERP_InvalidOrder`, { params: params }); };
//获取单条发货通知单
export const CreateSendGoodsByOrderId = params => { return axios.get(`${base}/api/Order/CreateSendGoodsByOrderId`, { params: params }); };
//生成出货单
export const ERP_SendGoodsAdd = params => { return axios.post(`${base}/api/SendGoods/ERP_SendGoodsAdd`, params, config); };
//更新出货单
export const ERP_SendGoodsUpdate = params => { return axios.post(`${base}/api/SendGoods/ERP_SendGoodsUpdate`, params, config); };

//获取单条发货单数据
export const GetERP_SendGoodsById = params => { return axios.get(`${base}/api/SendGoods/GetERP_SendGoodsById`, { params: params }); };
//加载数据
export const LoadDataForSendGoodsEdit = params => { return axios.get(`${base}/api/SendGoods/LoadDataForSendGoodsEdit`, { params: params }); };
//销售下单审核（待审核、已审核）
export const GetOrderAuditStatistics = params => { return axios.get(`${base}/api/Order/GetOrderAuditStatistics`, { params: params }); };

//财务审核
export const GetOrderFinanceAuditByPage = params => { return axios.get(`${base}/api/Order/GetOrderFinanceAuditByPage`, { params: params }); };


// WEBPACK FOOTER //
// ./src/api/orderApi.js